import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ApolloInstances } from '../graphql.module';
import GET_CONTRACT_CATEGORIZATION_SCHEMES from './queries/get-contract-categorization-schemes';
import { map } from 'rxjs/operators';
import {
  CategorizationScheme,
  PublicCategorizationSchemes,
} from '@aptitude/shared-vanilla';

@Injectable({
  providedIn: 'root',
})
export class ContractGraphqlService {
  constructor(private apollo: Apollo) {}

  /**
   * Fetches contract categorization schemes using the GraphQL API.
   *
   * @param useNewPscLabel - Indicates whether to use the new PSC label ("CC") or not.
   *   This should be set to `true` if the `PSC_REBRANDING_PTHLA_1056838` feature flag is enabled,
   *   and `false` otherwise. Once the feature flag is retired and the new label is standard,
   *   this parameter should default to `true`.
   * @returns An Observable that emits an array of categorization schemes, with the PSC label replaced if applicable.
   */
  getContractCategorizationSchemes(useNewPscLabel = false) {
    return this.apollo
      .use(ApolloInstances.CONTRACT)
      .query<{
        contractCategorizationSchemes: Array<CategorizationScheme>;
      }>({
        query: GET_CONTRACT_CATEGORIZATION_SCHEMES,
        fetchPolicy: 'no-cache',
      })
      .pipe(
        map((request) => request.data.contractCategorizationSchemes ?? []),
        map((contractCategorizationSchemes) => {
          if (!useNewPscLabel) {
            return contractCategorizationSchemes;
          }

          return contractCategorizationSchemes.map((scheme) =>
            scheme.id === PublicCategorizationSchemes.CC //PSC
              ? { ...scheme, name: 'CC' }
              : scheme,
          );
        }),
      );
  }
}
